'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialReddit = function IoSocialReddit(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm37.6 19.6c0 1.6-0.9 2.9-2.1 3.5 0 0.4 0 0.7 0 1.1 0 6-6.9 10.8-15.5 10.8s-15.5-4.8-15.5-10.7c0-0.4 0-0.8 0.1-1.2-1.2-0.6-2.1-1.9-2.1-3.5 0-2.2 1.8-3.9 3.9-3.9 1 0 1.9 0.4 2.6 1 2.6-1.8 6.2-3 10.1-3.2h0.1l2.4-8 7.1 1.4c0.6-1.1 1.7-1.9 3-1.9h0.1c2 0 3.4 1.6 3.4 3.5s-1.4 3.5-3.4 3.5h-0.1c-1.8 0-3.3-1.3-3.4-3.1l-5.3-1.1-1.7 5.8c3.9 0.2 7.3 1.3 9.8 3.1 0.7-0.6 1.6-1 2.7-1 2.1 0 3.8 1.7 3.8 3.9z m-32.4 1.6c0.3-1.2 1.1-2.3 2.2-3.2-0.3-0.3-0.7-0.4-1.1-0.4-1.1 0-2 0.8-2 1.9 0 0.7 0.3 1.4 0.9 1.7z m25.3-12.7c0 0.7 0.5 1.3 1.2 1.3s1.3-0.6 1.3-1.3-0.6-1.3-1.3-1.3-1.2 0.6-1.2 1.3z m-18.1 14c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5-1.1-2.4-2.5-2.4-2.5 1-2.5 2.4z m7.6 8.8c3.7 0 6-2.3 6.1-2.4l-1-0.9s-2 1.8-5.1 1.8c-3.2 0-5-1.8-5-1.8l-1 0.9c0.1 0.1 2.2 2.4 6 2.4z m5.2-6.3c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.4-2.5-2.4-2.5 1-2.5 2.4 1.1 2.5 2.5 2.5z m9.7-3.7c0.6-0.4 0.9-1.1 0.9-1.8 0-1.1-0.9-1.9-2-1.9-0.4 0-0.8 0.1-1.1 0.4 1.1 0.9 1.8 2.1 2.2 3.3z' })
        )
    );
};

exports.default = IoSocialReddit;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-reddit.js
// module id = 2465
// module chunks = 0